
const initialState = {
    leaves: [],
    leaveBalance: [],
    
    error: null,
    isLoding: false
  };

const LeaveApiReducer = (state = initialState, action) => {
    switch (action.type) {
      case "LOADING":
        return {
          ...state,
          isLoding: action.payload
        };
  
      case "GET_LEAVES_SUCCESS":
        return {
          ...state,
          leaves: action.payload,
          error: null
        };
      case "GET_LEAVES_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
  
      case "ADD_LEAVES_SUCCESS":
        return {
          ...state,
          error: null
        };
      case "ADD_LEAVES_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };

      case "UPDATE_LEAVE_SUCCESS":
          return{
            ...state,
            error: action.payload.error
          };
        
      case "UPDATE_LEAVE_FAILURE":
          return{
            ...state,  
            error: action.payload.error
          };
      case "GET_LEAVEBALANCE_SUCCESS":
        return {
          ...state,
          leaveBalance: action.payload,
          error: null
        };
      case "GET_LEAVEBALANCE_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
    
      case "ADD_LEAVEBALANCE_SUCCESS":
        return {
          ...state,
          error: null
        };
      case "ADD_LEAVEBALANCE_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
      case "UPDATE_LEAVEBALANCE_SUCCESS":
          return{
            ...state,
            error: action.payload.error
          };
        
      case "UPDATE_LEAVEBALANCE_FAILURE":
          return{
            ...state,  
            error: action.payload.error
          };

    
  
      default:
        return state;
    }
  };
  
  export default LeaveApiReducer;